export default {
  mode: 'history',
  routes: [
    {
      path: '/force-login',
      name: 'ForceLogin',
      component: () => import('@Views/ForceLogin'),
    },
    {
      path: '/callback.html',
      name: 'Callback',
      component: () => import('@Views/Callback'),
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('@Views/Home'),
    },
    {
      path: '/lexicon',
      name: 'lexicon',
      component: () => import('@Views/LexiconPage.vue'),
      children: [
        {
          path: 'anatomie',
          name: 'anatomie',
          component: () => import('@Components/Lexicon/anatomie.vue'),
        },
        {
          path: 'astigmatisme',
          name: 'astigmatisme',
          component: () => import('@Components/Lexicon/astigmatisme.vue'),
        },
      ],
    },
    {
      path: '/error',
      name: 'Error',
      component: () => import('@Views/Error'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@Views/Login'),
      meta: {
        allowUnauthenticatedAccess: true,
      },
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('@Views/Settings'),
    },
    {
      path: '/products',
      name: 'Products',
      component: () => import('@Views/DiscoverOurProducts'),
    },
    {
      path: '/relate/:step',
      name: 'Relate',
      component: () => import('@Views/Relate'),
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('@Views/Logout'),
    },
    {
      path: '/Understand',
      name: 'Understand',
      component: () => import('@Views/UnderstandPage'),
    },
    {
      path: '/player',
      component: () => import('@Views/DemoStoreLoader'),
      children: [
        {
          path: '/',
          name: 'frameUnderstand',
          component: () => import('@Views/FrameVideo'),
          children: [
            {
              path: ':category/:nameVideo',
              name: 'videoUnderstand',
              meta: {
                id: 'nameVideo',
              },
              component: () => import('@Components/Demos/Video/DemoVideo.vue'),
            },
            {
              path: 'product/:youtubeId/:title',
              name: 'videoProduct',
              meta: {
                id: 'youtubeId',
              },
              component: () => import('@Components/Demos/Video/DemoVideo.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/demos',
      name: 'StoreLoader',
      component: () => import('@Views/DemoStoreLoader'),
      children: [
        {
          path: 'configurator/:correct?/:protect?/:optimize?',
          name: 'Configurator',
          component: () => import('@Views/ConfiguratorPage'),
        },
        {
          path: ':id',
          name: 'Demo',
          component: () => import('@Views/Demos/Frame'),

          children: [
            {
              path: '360/:idSituation',
              name: '360',
              meta: {
                id: '360',
              },
              // component: () => import("@Components/Demos/360/360")
              component: () => import('@Components/Demos/360/360Babylon'),
            },
            {
              path: 'video/:idSituation',
              name: 'video',
              meta: {
                id: 'video',
              },

              component: () => import('@Components/Demos/Video/DemoVideo.vue'),
            },
            {
              path: 'videoSlider/:idSituation',
              name: 'videoSlider/:idSituation',
              meta: {
                id: 'videoSlider',
              },
              component: () => import('@Components/Demos/Slider/SliderVideoLuminosity.vue'),
            },
            {
              path: 'videoBlur/:idSituation',
              name: 'videoBlur/:idSituation',
              meta: {
                id: 'videoBlur/:idSituation',
              },
              component: () => import('@Components/Demos/Slider/SliderVideoBlur'),
            },
            {
              path: 'photo/:idSituation',
              name: 'photo/:idSituation',
              meta: {
                id: 'photo/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/DemoPhoto.vue'),
            },
            {
              path: 'specific/:idSituation',
              name: 'specific/:idSituation',
              meta: {
                id: 'specific/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/DemoSpecific.vue'),
            },
            {
              path: 'photoCompareMode/:idSituation',
              name: 'photoCompareMode/:idSituation',
              meta: {
                id: 'photoCompareMode/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/PhotoCompareMode.vue'),
            },
            {
              path: 'videoCompare/:idSituation',
              name: 'videoCompare/:idSituation',
              meta: {
                id: 'videoCompare/:idSituation',
              },
              component: () => import('@Components/Demos/Video/DemoVideo.vue'),
            },
            {
              path: 'compareSlider/:idSituation',
              name: 'compareSlider/:idSituation',
              meta: {
                id: 'compareSlider/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/CompareSlider.vue'),
            },
            {
              path: 'compareStairs/:idSituation',
              name: 'compareStairs/:idSituation',
              meta: {
                id: 'compareStairs/:idSituation',
              },
              component: () => import('@Components/Demos/Stairs/StairsCompare.vue'),
            },
            {
              path: 'transitions/:idSituation',
              name: 'transitions/:idSituation',
              meta: {
                id: 'transitions/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/Transitions.vue'),
            },
            {
              path: 'diaporama/:idSituation',
              name: 'diaporama/:idSituation',
              meta: {
                id: 'diaporama/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/Diaporama.vue'),
            },
            {
              path: '*',
              name: 'Error404',
              component: () => import('@Views/Error404'),
            },
          ],
        },
        {
          path: '*',
          name: 'Error404',
          component: () => import('@Views/Error404'),
        },
      ],
    },
    {
      path: '*',
      name: 'Error404',
      component: () => import('@Views/Error404'),
    },
  ],
};
